module.exports = __webpack_public_path__ + "static/img/75.eca9aef.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/75.png
// module id = cOx5
// module chunks = 1